import { render, staticRenderFns } from "./oneBuy.vue?vue&type=template&id=3f159e38&scoped=true&"
import script from "./oneBuy.vue?vue&type=script&lang=js&"
export * from "./oneBuy.vue?vue&type=script&lang=js&"
import style0 from "./oneBuy.vue?vue&type=style&index=0&id=3f159e38&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f159e38",
  null
  
)

export default component.exports